/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Body_Composition_Analysis_TermsInputs */

const en_service_type_body_composition_analysis_terms = /** @type {(inputs: Service_Type_Body_Composition_Analysis_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inbody, tanita, body fat, body measurements`)
};

const pl_service_type_body_composition_analysis_terms = /** @type {(inputs: Service_Type_Body_Composition_Analysis_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inbody, tanita, skład ciała, tkanka tłuszczowa, pomiar tłuszczu, pomiary ciała`)
};

/**
* | output |
* | --- |
* | "inbody, tanita, body fat, body measurements" |
*
* @param {Service_Type_Body_Composition_Analysis_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_body_composition_analysis_terms = /** @type {((inputs?: Service_Type_Body_Composition_Analysis_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Body_Composition_Analysis_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_body_composition_analysis_terms(inputs)
	return en_service_type_body_composition_analysis_terms(inputs)
});